/**
 *
 * Integrations
 *
 */

import React, { memo } from 'react';

import { Route, Routes } from 'react-router-dom';

import { IntegrationCards } from 'containers/Setup/Integrations/Components/IntegrationCards';
import { IntegrationsTable } from 'containers/Setup/Integrations/Components/IntegrationsTable';
import { IntegrationsWizard } from 'containers/Setup/Integrations/Components/IntegrationsWizard';
import { useInjector } from 'utils/inject';

import { integrationsSaga } from './saga';
import { reducer, sliceKey } from './slice';

export const Integrations = memo(() => {
  useInjector(sliceKey, reducer, integrationsSaga);

  return (
    <Routes>
      <Route index element={<IntegrationCards />} />
      <Route path="/:provider" element={<IntegrationsTable />} />
      <Route path="/sso/:provider" element={<IntegrationsTable />} />
      <Route path="/add/:provider" element={<IntegrationsWizard />} />
      <Route path="/add/sso/:provider" element={<IntegrationsWizard />} />
      <Route path="/edit/:provider/:id" element={<IntegrationsWizard />} />
    </Routes>
  );
});
